export const UNIT_PAGE_LAYOUT_CONTENT_BODY_PADDING = "2rem";
export const UNIT_TITLE_HEIGHT = "45.3px";
export const UNIT_CONTENT_WRAPPER_GAP = "1rem";
